import { messageLogin, messageLoginEmpty, showMessageLogin } from "@/event/account/alert/messageLogin"

export function toggleAlertLoginHappy() {
    showMessageLogin.value = false
    setTimeout(() => {
        messageLogin.value = messageLoginEmpty
    }, 500)
}